import {Component, OnDestroy, OnInit} from "@angular/core";
import {App, NavController, ViewController} from "ionic-angular";
import {ProfilePage} from "../../../pages/profile/profile.page";
import {AppAuth} from "../../core/auth";
import {ToastService} from "../../core/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {UsersPage} from "../../../pages/users/users.page";
import {RoleService} from "../../core/role.service";

@Component({
  templateUrl: 'menu.component.html',
})
export class MenuComponent implements OnInit, OnDestroy{
  private nav: NavController;
  private roleSub: any;
  role: string = null;

  constructor(
    private viewCtrl: ViewController,
    private app: App,
    private toast:  ToastService,
    private translate: TranslateService,
    private roleService: RoleService,
    public auth: AppAuth
  ) {
    this.nav = this.app.getRootNav();
  }

  ngOnInit(){
    this.roleSub = this.roleService.getRole()
      .subscribe(role => this.role = role);
  }

  ngOnDestroy(){
    this.roleSub.unsubscribe();
  }

  goToProfile(){
    this.nav.push(ProfilePage);
    this.viewCtrl.dismiss();
  }

  goToUsers(){
    this.nav.push(UsersPage);
    this.viewCtrl.dismiss();
  }

  logout() {
    this.viewCtrl.dismiss();
    this.auth.logout()
      .subscribe((res) => {
        this.toast.show(this.translate.instant('global.logged_out'));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.component.ts